export default __webpack_public_path__ + "static/media/06.79a092f1.jpg";